module.exports = __webpack_public_path__ + "ai.no1.afff5601.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/stories/aoyama/child_to_parent/ai.no1.jpg
// module id = RvxE
// module chunks = 0